import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IObraDisciplinesRequest } from 'Data/interfaces/Obra/IObraDisciplines';

export const useQueryUpdateDisciplinesObra = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IObraDisciplinesRequest) => {
      return ObrasApiV2.updateDisciplines(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        }),
      ]);

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (oldData) => {
        return oldData?.map((obra) => {
          if (obra.ConstructionSiteId === variables.constructionStieId) {
            return {
              ...obra,
              Disciplines: data.data,
            };
          }
          return obra;
        });
      });
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        (oldData) => {
          if (oldData && oldData.ConstructionSiteId === variables.constructionStieId) {
            return {
              ...oldData,
              Disciplines: data.data,
            };
          }
          return oldData;
        },
      );

      toastHandler.showSuccess('Disciplinas da Obra atualizadas com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao atualizar Disciplinas!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    updateDisciplinesObra: mutate,
    isLoading: isPending,
  };
};
